export const DietProductionStepItem = (json: IDietProductionStepItem): IDietProductionStepItemModel => {
	const { is_active, updated_at, created_at, ...rest } = json

	return {
		...rest,
		isActive: is_active,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const dietProductionStepItemToJSON = (model: IDietProductionStepItemModel): IDietProductionStepItem => {
	const { isActive, createdAt, updatedAt, ...rest } = model

	return {
		...rest,
		is_active: isActive ? isActive : false,
		created_at: createdAt ? createdAt.toISOString() : null,
		updated_at: updatedAt ? updatedAt.toISOString() : null,
	}
}

export const DietProductionStep = (json: IDietProductionStep): IDietProductionStepModel => {
	const { production_stage_id, production_stage, parameter_settings, id, ...rest } = json

	return {
		...rest,
		id: id ?? 0, // Ensure id is always a number
		productionStageId: production_stage_id,
		productionStage: DietProductionStepItem(production_stage),
		parameterSettings: parameter_settings,
	}
}

// TODO: Check if this is correct
export const dietProductionStepToJSON = (model: IDietProductionStepModel): IDietProductionStep => {
	const { productionStageId, productionStage, parameterSettings, ...rest } = model

	return {
		...rest,
		production_stage_id: productionStageId,
		production_stage: dietProductionStepItemToJSON(productionStage),
		parameter_settings: parameterSettings,
	}
}

export const DietProductionStepForm = (json: IDietProductionStepModel): IDietProductionStepFormModel => {
	const { components, parameterSettings, order, description, productionStage, productionStageId } = json

	return {
		productionStageId,
		productionStage,
		order,
		description,
		parameterSettings,
		components: components.map(c => ({ id: c.id, type: c.type })),
	}
}

// TODO: To implement
export const DietProductionStepToForm = (model: IDietMealProductionStepModel): IDietProductionStepFormModel => {
	const { order, productionStage, description, parameterSettings } = model

	return {
		order,
		description,
		parameterSettings,
		productionStageId: productionStage.id,
		productionStage: { value: productionStage.id, label: productionStage.name },
		components: [],
	}
}

/**
 * Payloads
 */
export const DietProductionStepToPayload = (model: IDietProductionStepModel): IDietProductionStepPayload => {
	const { productionStage, components, parameterSettings, ...rest } = model

	return {
		...rest,
		production_stage_id: productionStage.value,
		parameter_settings: parameterSettings,
		// components: [],
	}
}
